module.exports = __webpack_public_path__ + "img/skillsbg.1cf22bbb.jpg";